import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const About = () => {
  const timelineEvents = [
    {
      year: '2025',
      title: 'The Start of AlonForge',
      description: 'AlonForge Solutions officially launched, dedicated to forging digital solutions for Filipino freelancers and small businesses',
    },
  ];

  const values = [
    {
      title: 'Bayanihan in Code',
      description:
        'Community-first approach, helping fellow Pinoys succeed in the digital space.',
    },
    {
      title: 'Fast as Agos',
      description:
        'Quick turnaround times without compromising quality—we move with the current.',
    },
    {
      title: 'Affordable for Pinoy Hustle',
      description:
        'Fair pricing that respects the Filipino freelancer budget and hustle.',
    },
  ];

  return (
    <>
      <Helmet>
        <title>AlonForge Solutions | About</title>
        <meta
          name="description"
          content="Learn about Alwin Alon and AlonForge Solutions—forging IT solutions for Filipino creators"
        />
      </Helmet>

      <div className="min-h-screen bg-slate">
        {/* Hero Section */}
        <div className="bg-gradient-to-br from-navy to-skyblue py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="w-32 h-32 mx-auto mb-6 rounded-full bg-white/20 flex items-center justify-center">
                <span className="text-4xl">👨‍💻</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 font-heading">
                Alwin Alon
              </h1>
              <p className="text-xl md:text-2xl mb-4 font-heading">
                BSIS Forger of UI & Systems
              </p>
              <p className="text-lg">
                Blending Filipino alon with code. From capstone projects to
                freelance success, I build tools that help you ride your own
                wave—UI portfolios and IT systems crafted for Pinoy hustlers.
              </p>
            </motion.div>
          </div>
        </div>

        {/* Timeline */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
              Journey
            </h2>
            <div className="flex flex-col items-center relative">
              {/* Vertical Line */}
              <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-skyblue"></div>

              {timelineEvents.map((event, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  className={`relative mb-12 w-full md:w-1/2 ${
                    index % 2 === 0 ? 'md:pr-8 md:text-right' : 'md:pl-8 md:ml-auto md:text-left'
                  }`}
                >
                  <div className="absolute top-4 left-1/2 transform -translate-x-1/2 md:left-auto md:transform-none md:right-0 md:translate-x-1/2 w-4 h-4 bg-skyblue rounded-full border-4 border-white shadow-lg z-10"></div>
                  <div className="bg-white rounded-lg shadow-md p-6">
                    <div className="text-skyblue font-bold text-lg mb-2">
                      {event.year}
                    </div>
                    <h3 className="text-xl font-semibold mb-2">{event.title}</h3>
                    <p className="text-gray-600">{event.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
              Team
            </h2>
            <div className="max-w-md mx-auto bg-slate rounded-lg shadow-md p-8 text-center">
              <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-navy flex items-center justify-center text-white text-3xl">
                AA
              </div>
              <h3 className="text-2xl font-bold mb-2 font-heading">Alwin Alon</h3>
              <p className="text-skyblue font-semibold mb-4">
                Founder & Wave-Forger
              </p>
              <p className="text-gray-600">
                Building IT solutions with a Pinoy heart, one project at a time.
              </p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-20 bg-slate">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
              Our Values
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {values.map((value, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  className="bg-white rounded-lg shadow-md p-6"
                >
                  <h3 className="text-xl font-semibold mb-4 text-skyblue font-heading">
                    {value.title}
                  </h3>
                  <p className="text-gray-600">{value.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;

